// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `This competition has ended.`
};

const de_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Dieses Gewinnspiel ist beendet.`
};

const es_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Esta competencia ha terminado.`
};

const fr_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Ce concours est terminé.`
};

const fi_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Tämä kilpailu on päättynyt.`
};

const hi_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `यह प्रतियोगिता समाप्त हो गई है।`
};

const ja_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `このコンテストは終了しました。`
};

const nl_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Deze wedstrijd is afgelopen.`
};

const pt_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Este concurso terminou.`
};

const ro_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Acest concurs s-a încheiat.`
};

const th_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `การแข่งขันนี้สิ้นสุดลงแล้ว`
};

const ur_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `یہ مقابلہ ختم ہو گیا ہے۔`
};

const zh_hant1_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `此競賽已結束。`
};

const da_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Denne konkurrence er afsluttet.`
};

const it_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Questa competizione è terminata.`
};

const vn_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Cuộc thi này đã kết thúc.`
};

const ko_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `이 경품 이벤트가 종료되었습니다.`
};

const tr_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Bu yarışma sona erdi.`
};

const lv_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Šī sacensība ir beigusies.`
};

const ar_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `انتهت هذه المسابقة.`
};

const bs_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Ova nagradna igra je završena.`
};

const sl_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `To tekmovanje se je končalo.`
};

const id_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Kompetisi ini telah berakhir.`
};

const sv_widget_competition_ended = /** @type {(inputs: {}) => string} */ () => {
	return `Denna tävling har avslutats.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_competition_ended = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_competition_ended(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_competition_ended", locale)
	if (locale === "en") return en_widget_competition_ended(inputs)
	if (locale === "de") return de_widget_competition_ended(inputs)
	if (locale === "es") return es_widget_competition_ended(inputs)
	if (locale === "fr") return fr_widget_competition_ended(inputs)
	if (locale === "fi") return fi_widget_competition_ended(inputs)
	if (locale === "hi") return hi_widget_competition_ended(inputs)
	if (locale === "ja") return ja_widget_competition_ended(inputs)
	if (locale === "nl") return nl_widget_competition_ended(inputs)
	if (locale === "pt") return pt_widget_competition_ended(inputs)
	if (locale === "ro") return ro_widget_competition_ended(inputs)
	if (locale === "th") return th_widget_competition_ended(inputs)
	if (locale === "ur") return ur_widget_competition_ended(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_competition_ended(inputs)
	if (locale === "da") return da_widget_competition_ended(inputs)
	if (locale === "it") return it_widget_competition_ended(inputs)
	if (locale === "vn") return vn_widget_competition_ended(inputs)
	if (locale === "ko") return ko_widget_competition_ended(inputs)
	if (locale === "tr") return tr_widget_competition_ended(inputs)
	if (locale === "lv") return lv_widget_competition_ended(inputs)
	if (locale === "ar") return ar_widget_competition_ended(inputs)
	if (locale === "bs") return bs_widget_competition_ended(inputs)
	if (locale === "sl") return sl_widget_competition_ended(inputs)
	if (locale === "id") return id_widget_competition_ended(inputs)
	if (locale === "sv") return sv_widget_competition_ended(inputs)
	return "widget_competition_ended"
};